function retrieval_step1() {
  var self = this;

  this.init = function () {

    this.validateApplication();
    this.bindEvents();

  }

  this.validateApplication = function () {

    var formHasBeenSubmitted = false;

    $("#retrieval_step1").validate({

      ignore: ":hidden",
      onkeyup: false,

      highlight: function(element) {
        if (!formHasBeenSubmitted) return;

        if (element.type === "radio") {
          $(element)
            .closest('.donation-group')
            .addClass('invalid');
        } else {
          $(element)
            .closest('.text-input')
            .addClass('invalid');
        }
      },

      unhighlight: function(element) {
        if (!formHasBeenSubmitted) return;

        if (element.type === "radio") {
          var group = $(element).closest('.donation-group');

          // only mark valid if one is checked
          if ($('input[name="' + element.name + '"]:checked').length) {
            group.removeClass('invalid');
          }
        } else {
          $(element)
            .closest('.text-input')
            .removeClass('invalid');
        }
      },

      /*  ios8 & above only scroll back to the focus of the first error. If you hit submit again & there is another error
          it will not scroll. This confuses the user as they do not think there is another error message. This code fixes that. */
      invalidHandler: function(e, validator) {
        formHasBeenSubmitted = true;

        if (window.navigator.userAgent.match(/iphone/i)) {
          window.setTimeout(function() {

            var el = $(validator.errorList[0].element);

            var target = el.attr("type") === "radio"
              ? el.closest('.donation-group')
              : el;

            $("html,body").animate({
              scrollTop: target.offset().top
            });

          }, 0);
        }
      },

      errorPlacement: function(error, element) {
        error.addClass('input-error caption');

        if (element.attr("type") === "radio") {
          error.insertAfter(element.closest('.donation-group'));
        } else {
          var wrapper = element.closest('.text-input-wrapper');
          var description = wrapper.find('.input-description');

          if (description.length) {
            error.insertBefore(description);
          } else {
            wrapper.append(error);
          }
        }
      },


      rules: {

      },

      messages: {
        email: {
          required: 'Enter your email address',
          email: 'Enter an email address in the correct format, like name@example.com'
        }
      },

      submitHandler: function(form) {

        grecaptcha.ready(function() {
          grecaptcha.execute('6LeP_rkUAAAAAO2GHVS31IwO4Zquu0aA7F0ZSYpc', {action: 'homepage'}).then(function(token) {
            jQuery('#retrieval_step1').prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '">');
            form.submit();
          });
        });

      }

    });

  }

  this.bindEvents = function () {

  }

}

module.exports = retrieval_step1;
